import styled from 'styled-components'

export const Options = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${props => props.theme.spacing.sp16};
  width: 100%;
`
